import React from 'react';
import Navigation from './components/Navigation';

function TermsOfService() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navigation />

      <div className="max-w-3xl mx-auto px-4 py-12">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Terms of Service</h1>
          <p className="text-sm text-gray-500">Last updated: [DATE]</p>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-gray-200 divide-y divide-gray-100">

          <Section title="1. Acceptance of Terms">
            [PLACEHOLDER]
          </Section>

          <Section title="2. Description of Service">
            <p>
              Gifted is a marketplace for community mutual aid, enabling peer-to-peer gifting and fundraising.
              This platform is designed to facilitate transparent, trust-based support between individuals.
              All users must comply with these Terms and our Acceptable Use Policy before sending or receiving funds.
            </p>
          </Section>

          <Section title="3. User Accounts">
            [PLACEHOLDER]
          </Section>

          <Section title="4. Payments & Fees">
            [PLACEHOLDER]
          </Section>

          <Section title="5. Prohibited Uses">
            <p className="mb-3">Users are strictly prohibited from using Gifted for:</p>
            <ul className="space-y-2">
              <Li label="Fraud & Deception">
                Misrepresenting a need, using stolen identities, or creating multiple accounts to circumvent limits.
              </Li>
              <Li label="Prohibited Financial Schemes">
                Pyramid or Ponzi schemes, "money flipping," or investment opportunities.
              </Li>
              <Li label="Restricted Goods">
                Soliciting funds for weapons, narcotics, tobacco, or adult-oriented services.
              </Li>
              <Li label="Raffles & Gambling">
                Any campaign where a donor pays for a chance to win a prize.
              </Li>
              <Li label="Regulated Content">
                Campaigns related to political lobbying or campaigning without explicit platform approval.
              </Li>
            </ul>
          </Section>

          <Section title="6. Verification & Moderation">
            <ul className="space-y-2">
              <Li label="Proof of Need">
                Gifted may request documentation (e.g., invoices, redacted medical bills) to verify the legitimacy of a post.
              </Li>
              <Li label="Hold Period">
                To prevent fraud, funds may be subject to a moderation hold via our payment processor before disbursement.
              </Li>
              <Li label="Non-Custodial Disclaimer">
                Gifted does not act as a fiduciary or escrow agent. All transactions are peer-to-peer and Gifted is not a party to the contract between sender and recipient.
              </Li>
            </ul>
          </Section>

          <Section title="7. Enforcement">
            <p className="mb-3">Violations of these Terms may result in:</p>
            <ul className="space-y-1 list-disc list-inside text-sm text-gray-600">
              <li>Immediate removal of the post and voiding of pending payments.</li>
              <li>Permanent suspension or blacklisting of the user and linked financial accounts.</li>
              <li>Reporting of suspicious activity to PayPal and/or law enforcement.</li>
            </ul>
          </Section>

          <Section title="8. Third-Party Terms">
            <p>
              All users must comply with{' '}
              <a
                href="https://www.paypal.com/us/legalhub/acceptableuse-full"
                target="_blank"
                rel="noopener noreferrer"
                className="text-indigo-600 hover:underline"
              >
                PayPal's Acceptable Use Policy
              </a>{' '}
              when connecting accounts.
            </p>
          </Section>

          <Section title="9. Content & Conduct">
            [PLACEHOLDER]
          </Section>

          <Section title="10. Disclaimers">
            [PLACEHOLDER]
          </Section>

          <Section title="11. Limitation of Liability">
            [PLACEHOLDER]
          </Section>

          <Section title="12. Changes to Terms">
            [PLACEHOLDER]
          </Section>

          <Section title="13. Contact">
            [PLACEHOLDER]
          </Section>

        </div>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div className="px-6 py-6">
      <h2 className="text-base font-semibold text-gray-900 mb-3">{title}</h2>
      <div className="text-sm text-gray-600 leading-relaxed space-y-2">{children}</div>
    </div>
  );
}

function Li({ label, children }) {
  return (
    <li className="flex gap-2">
      <span className="text-gray-400 mt-0.5">•</span>
      <span><span className="font-medium text-gray-700">{label}:</span> {children}</span>
    </li>
  );
}

export default TermsOfService;
